import React from "react";
import { GaugeVariant } from "@trp-beacon-ui-kit/foundation/dist/_common/enums/gauge-chart";
import { ReducedScaleVariant } from "@trp-beacon-ui-kit/foundation/dist/_common/enums/scale";

import {
  RicBeaconGaugeChart,
  RicBeaconIconButton,
  RicBeaconIcon,
  RicBeaconModal,
} from "./BeaconRegister";
import { LegendIcon } from "../../assets/images/LegendIcon";
import { Box } from "@mui/system";
import { showModal } from "../../Utils";

export const SuccessProbabilityMeter = ({
  confidenceScoreResult,
  min = 0,
  max = 100,
}) => {
  const chartOptions = {
    chart: {
      // height: 500,
      marginTop: 0,
      marginBottom: 0,
      spacingTop: 0,
      spacingBottom: 0,
      // width: 400,
    },
    pane: {
      // center: ['50%', '50%'],
      size: "100%",
    },
  };

  return (
    <div
      id="success-probability-meter"
      className="beacon-theme-modern-outlook"
      style={{
        textAlign: "center",
        background: "#F4F5F6",
        width: "100%",
        height: "85%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "end",
        alignItems: "center",
      }}
    >
      <RicBeaconGaugeChart
        options={chartOptions}
        variant={GaugeVariant.TARGET}
        gaugeValueProp={confidenceScoreResult}
        gaugeTarget={min}
        targetRange={max - min}
        style={{
          "--beacon-system-color-background-1":
            "var(--beacon-system-color-background-2)",

          width: "80%",
          "--beacon-system-font-size-sans-serif-headline-100":
            "var(--beacon-system-font-size-sans-serif-body-100)",
          height: "100%",
          cursor: "default !important",
        }}
        percentage
        metricScale={ReducedScaleVariant.MINI}
        metricDescription="Probability of Success"
        disableExporting
        staticLegend
        disableLegend
        hideLabels
      />

      <Box
        className="b-typography-sans-serif--headline-loose--300 b-font-weight-bold"
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box
          id="chart-legend"
          sx={{
            alignSelf: "center",
            display: "flex",
            gap: "var(--beacon-reference-space-4)",
            alignItems: "center",
          }}
        >
          <Box id="legend-icon" sx={{ display: "flex" }}>
            {<LegendIcon />}
          </Box>
          <Box
            id="confidence-zone-text"
            className="b-typography-sans-serif--body--100"
          >
            {" "}
            Confidence Zone
          </Box>
          <Box
            id="confidence-zone-range"
            className="b-typography-sans-serif--body--100 b-font-weight-bold"
          >
            {min} - {max}%
          </Box>
          <Box display="flex" id="confidence-zone-info-button">
            <RicBeaconIconButton
              variant="tertiary"
              onClick={() => showModal("confidence-zone-modal")}
            >
              <RicBeaconIcon name="information" slot="icon" />
            </RicBeaconIconButton>
          </Box>
        </Box>
      </Box>
      <RicBeaconModal scale="normal" id="confidence-zone-modal" closeOnClickOut>
        <span className="b-typography-serif--headline--200 b-color-text--title">
          Confidence Zone
        </span>
        <p>
          The Retirement Income Calculator provides an estimated probability of
          success in reaching your retirement goal (i.e., not running out of
          money in retirement).
        </p>
        <p>
          The Confidence Zone ranges are determined by your age, or, if two
          clients are included, the age of the older client.
        </p>
        <ul>
          <li>
            For clients ages 44 and younger, the Confidence Zone is 70% to 95%.
          </li>
          <li>
            For clients ages 45 and over, the Confidence Zone is 80% to 95%.
          </li>
        </ul>
      </RicBeaconModal>
    </div>
  );
};
